import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HistoriaModeloConsultaDto, HistoriaModeloEdicaoDto, HistoriaModeloInsercaoDto, LHistoriaModeloDto } from '../dtos/modelos/historia-modelo-dto';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class HistoriaModeloService {

  constructor(private http: HttpClient, private url: UrlService) { }

  consultar(id: number): Observable<HistoriaModeloConsultaDto> {
    return this.http.get<HistoriaModeloConsultaDto>(this.url.url(`modelos/historias/${id}`));
  }

  listar(profissionalId?: number, ativo?: boolean): Observable<LHistoriaModeloDto[]> {
    let params: HttpParams = new HttpParams();
    
    if (profissionalId !== undefined && profissionalId !== null) {
      params = params.append('profissionalId', profissionalId);
    }

    if (ativo !== undefined && ativo !== null) {
      params = params.append('ativo', ativo);
    }

    return this.http.get<LHistoriaModeloDto[]>(this.url.url(`modelos/historias`), { params: params });
  }

  salvar(dto: HistoriaModeloInsercaoDto | HistoriaModeloEdicaoDto): Observable<HistoriaModeloConsultaDto> {
    if ('id' in dto) {
      return this.http.patch<HistoriaModeloConsultaDto>(this.url.url('modelos/historias'), dto);
    }

    return this.http.post<HistoriaModeloConsultaDto>(this.url.url('modelos/historias'), dto);
  }

  excluir(id: number): Observable<void> {
    return this.http.delete<void>(this.url.url(`modelos/historias/${id}`));
  }
}
